
import { EventFormFields } from "../create-event/form/EventFormFields";
import { Event } from "@/types/event";
import { stringsArrayToDates } from "@/utils/dateUtils";
import { useEventFormFields } from "./hooks/useEventFormFields";
import { EventFormActions } from "./components/EventFormActions";
import { useEffect } from "react";

interface EventEditFormProps {
  event: Event;
  onChange: (updatedEvent: Event) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

export const EventEditForm = ({
  event,
  onChange,
  onSave,
  onCancel,
  isSaving = false,
}: EventEditFormProps) => {
  const {
    titleError,
    setTitleError,
    handleFieldChange,
    getEventImageData
  } = useEventFormFields(event, onChange);

  const { safeEventImages, nonPrimaryImageUrls } = getEventImageData();

  // Add effect to log event data when component mounts or event changes
  useEffect(() => {
    console.log('EventEditForm: Current event data:', {
      name: event.name,
      deadline: event.event_deadline,
      parsedDeadline: event.event_deadline ? new Date(event.event_deadline) : null
    });
  }, [event]);

  return (
    <div className="space-y-6">
      <div className="px-4">
        <EventFormFields
          title={event.name}
          setTitle={(value) => handleFieldChange("title", value)}
          description={event.description || ""}
          setDescription={(value) => handleFieldChange("description", value)}
          date={event.event_date ? new Date(event.event_date) : undefined}
          setDate={(value) => handleFieldChange("date", value)}
          // Convert string dates from DB to Date objects in local timezone
          preferredDates={event.preferred_dates ? stringsArrayToDates(event.preferred_dates) : []}
          setPreferredDates={(value) => handleFieldChange("preferredDates", value)}
          preferredTimeOfDay={event.preferred_time_of_day || []}
          setPreferredTimeOfDay={(value) => handleFieldChange("preferredTimeOfDay", value)}
          eventLocation={event.location_type === 'flexible' ? event.flexible_location_description || "" : ""}
          setEventLocation={(value) => handleFieldChange("eventLocation", value)}
          locationType={event.location_type || 'specific'}
          setLocationType={(value) => handleFieldChange("locationType", value)}
          titleError={titleError}
          setTitleError={setTitleError}
          imageUrl={event.image_url || ""}
          setImageUrl={(value) => handleFieldChange("imageUrl", value)}
          imageUrls={nonPrimaryImageUrls}
          setImageUrls={(value) => handleFieldChange("imageUrls", value)}
          setEventImages={(value) => handleFieldChange("eventImages", value)}
          eventImages={safeEventImages}
          preferredVenues={event.preferred_venues || []}
          setPreferredVenues={(value) => handleFieldChange("preferredVenues", value)}
          locationNote={event.flexible_location_description || ""}
          setLocationNote={(value) => handleFieldChange("locationNote", value)}
          guestList={event.guests || []}
          setGuestList={(value) => handleFieldChange("guestList", value)}
          eventId={event.event_id}
          eventDeadline={event.event_deadline ? new Date(event.event_deadline) : null}
          setEventDeadline={(value) => {
            console.log('EventEditForm: setting eventDeadline:', value);
            handleFieldChange("eventDeadline", value);
          }}
        />
      </div>

      {/* Bottom CTAs */}
      <EventFormActions
        onSave={() => {
          console.log('EventEditForm: Saving event with deadline:', event.event_deadline);
          onSave();
        }}
        onCancel={onCancel}
        isSaving={isSaving}
      />
    </div>
  );
};
